/**
 * Basis-URL für Drupal-Aufrufe, die aus dem Browser abgesetzt werden.
 *
 * TT-713: Im Browser laufen diese Requests über einen Same-Origin-Rewrite
 * (siehe `rewrites()` in next.config.js). Dadurch braucht es für localhost
 * und für Vercel-Preview-Domains keine CORS-Freigabe im Drupal, weil der
 * Browser gar keinen Cross-Origin-Request mehr macht: er ruft den eigenen
 * Next-Server auf, der serverseitig an Drupal weiterreicht.
 *
 * Serverseitig (SSR, getStaticProps, API-Routes) gibt es kein CORS und keinen
 * relativen Pfad-Kontext, dort wird deshalb weiter die absolute URL benutzt.
 *
 * Nicht verwenden für Medien-/Bild-URLs: die müssen absolut bleiben, damit
 * next/image sie über NEXT_IMAGE_DOMAIN optimieren kann (siehe absoluteUrl
 * in lib/utils.ts).
 *
 * Der Proxy ist bewusst opt-in über NEXT_PUBLIC_USE_DRUPAL_PROXY. Auf
 * Production ist die Direktverbindung im Drupal per CORS freigegeben, dort
 * wäre der Umweg über den Next-Server nur ein zusätzlicher Hop. Das Flag
 * gehört deshalb nur in Preview- und Development-Umgebungen.
 */
export const DRUPAL_PROXY_PREFIX = '/drupal-proxy';

const proxyEnabled = process.env.NEXT_PUBLIC_USE_DRUPAL_PROXY === 'true';

export const drupalBrowserBaseUrl =
  proxyEnabled && typeof window !== 'undefined'
    ? DRUPAL_PROXY_PREFIX
    : process.env.NEXT_PUBLIC_DRUPAL_BASE_URL;
